import { AuthForm } from "comps";

const Login = () => <AuthForm mode="login" />;

export default Login;
